import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { List, Card, Col, Row, Button, Select, Input, Checkbox, Divider, Tag, Dropdown, Menu, Upload } from 'antd';
import { DownOutlined, MailOutlined, UploadOutlined } from '@ant-design/icons';
import { Meta } from 'antd/lib/list/Item';
import * as moment from 'moment';
import GetExternalOrderStatesQuery from '../../../components/Query/OrderStates';
import PriceDisplay from '../../../components/Others/PriceDisplay';
import ShippingSettings from './ShippingSettings';
import OrderedItems from './OrderedItems/OrderedItems';
import PaymentSettings from './PaymentSettings';
import CustomerSettings from './CustomerSettings';
import InvoicingSettings from './InvoicingSettings';
import DeliverySettings from './DeliverySettings/DeliverySettings';
import WeightDisplay from '../../../components/Others/WeightDisplay';
import InvoiceNotesSettings from './InvoiceNotesSettings/InvoiceNotesSettings';
import { Icon } from '@ant-design/compatible';

interface IOrderInformationProps extends RouteComponentProps<{ orderId: string; eshop: string }> {
  order: GQL.IOrder;
  attributes: any;

  orderComments: Array<GQL.IOrderComment>;

  onUpdate: (data: any) => void;
  onChangeExternalOrderState: (newStateId: string | undefined) => void;
  onNewComment: (value: string, sendEmail: boolean) => void;
  onUploadToPohoda: (order: GQL.IOrder) => void;
  onUploadPurchaseQBOrder: (order: GQL.IOrder) => void;
  onAddAnotherProductItem: () => void;
  onAddAnotherNonProductItem: () => void;
  onEditItem: (item: GQL.IOrderItem) => void;
  onDeleteItem: (id: string) => void;
}

interface IOrderInformationState {
  newStateId?: string;
  newComment: string;
  sendEmail: boolean;
}

function createMarkup(content: string) {
  return { __html: content.replace(/(?:\r\n|\r|\n)/g, '<br />') };
}

class OrderInformation extends React.Component<IOrderInformationProps, IOrderInformationState> {

  constructor(props: IOrderInformationProps) {
    super(props);

    this.state = {
      newComment: '',
      sendEmail: false
    };

    this.getAttributes = this.getAttributes.bind(this);
  }

  public render() {
    const { order, orderComments } = this.props;
    const domain = this.props.match.params.eshop;
    const travisPohodaException = order.customer?.id === '79e13462-90c5-45e7-8f20-68e28f428a22';

    return (
      <div className="orderInformation">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
          <GetExternalOrderStatesQuery
            domain={domain}
          >
            {({ externalOrderStates }: any) => {
              if (externalOrderStates && externalOrderStates.externalOrderStates) {
                return (
                  <Select
                    style={{ width: '200px', marginRight: '5px' }}
                    onChange={(value: string) => this.setState({ newStateId: value })}
                    placeholder="Type"
                    defaultValue={
                      order.externalState ? order.externalState.id : undefined
                      // tslint:disable-next-line:jsx-curly-spacing
                    }
                  >
                    {externalOrderStates.externalOrderStates
                      .map(s => {
                        return (
                          <Select.Option key={s.id} value={s.id}>
                            {s.title}
                          </Select.Option>
                        );
                      })}
                  </Select>
                );
              }

              return (
                <span>loading...</span>
              );
            }}
          </GetExternalOrderStatesQuery>

          <Button
            disabled={
              (order.externalState != undefined && this.state.newStateId == order.externalState.id) ||
              this.state.newStateId == undefined
            }
            onClick={() => this.props.onChangeExternalOrderState(this.state.newStateId)}
            type={'primary'}
          >
            Change order status
          </Button>
          {/*{travisPohodaException &&
            <Button
              icon={<UploadOutlined />}
              type={'ghost'}
              style={{ margin: '0 5px' }}
              onClick={() => this.props.onUploadPurchaseQBOrder(order)}>
              QB Purchase
            </Button>}*/}
          {(order.currency && (['czk', 'eur', 'usd'].indexOf(order.currency.value.toLowerCase()) > -1)) &&
            <Button
              icon={<UploadOutlined />}
              type={'ghost'}
              onClick={() => this.props.onUploadToPohoda(order)}
            >
              Pohoda
            </Button>}
        </div>

        <Divider />

        <Row gutter={16}>
          <Col span={12}>
            <Card type="inner" title="General" bordered={false}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Order Date</span>
                <span>
                  {moment(new Date(order.createdAt)).local().format('DD/MM/YY hh:mm:ss')}
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Status</span>
                <span style={{ color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500, textAlign: 'right', marginRight: '-8px' }}>
                  {order.deliveryTotal === null &&
                    <Tag color={'red'}>Shipping price is not specified</Tag>}
                  {order.externalState && (
                    <Tag color={order.externalState.color || 'black'}>{order.externalState.title}</Tag>
                  )}
                  {order.paid &&
                    <Tag color={'red'}>Order paid</Tag>}
                  <Tag>{order.deliveryMethod.title}</Tag>
                  <Tag>{order.paymentMethod.title}</Tag>
                </span>
              </div>
              <Divider />

              <h3>Payment method(s)</h3>
              <PaymentSettings
                order={order}
                onUpdate={this.props.onUpdate}
              />

              <Divider />
              <h3>Delivery method</h3>
              <ShippingSettings
                order={order}
                onUpdate={this.props.onUpdate}
              />

              <Divider />
              <h3>Summary</h3>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Total excl. VAT</span>
                <span><PriceDisplay amount={order.subTotal} currency={order.currency} /></span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Total incl. VAT</span>
                <span><PriceDisplay amount={order.total} currency={order.currency} /></span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Delivery incl. VAT</span>
                {order.deliveryTotal === null &&
                  <span style={{ color: '#999897' }}>- not specified -</span>}
                {order.deliveryTotal !== null &&
                  <span><PriceDisplay amount={order.deliveryTotal} currency={order.currency} /></span>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Delivery insurance incl. VAT</span>
                <span>
                  {order.deliveryInsuranceTotal
                    ? <PriceDisplay amount={order.deliveryInsuranceTotal} currency={order.currency} />
                    : <span style={{ color: '#999897' }}>- not set -</span>}
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <span style={{ color: '#999897' }}>Payment incl. VAT</span>
                <span><PriceDisplay amount={order.paymentTotal} currency={order.currency} /></span>
              </div>
              {(order.tariffTotal && order.tariffTotal > 0) && (<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} >
                <span style={{ color: '#999897' }}>U.S. Reciprocal Import Tariff</span>
                <span><PriceDisplay amount={order.tariffTotal || 0} currency={order.currency} /></span>
              </div>)}
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} >
                <span style={{ color: '#999897' }}><b>Grand Total</b></span>
                <span><b><PriceDisplay amount={order.grandTotal} currency={order.currency} /></b></span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} >
                <span style={{ color: '#999897' }}>Total shipping weight</span>
                <span><WeightDisplay weight={this.getTotalShippingWeight() || undefined} /></span>
              </div>
            </Card>
          </Col>
          <Col span={12} >
            <Card
              type="inner"
              title="Customer"
              bordered={false}
              extra={
                order && order.customer ?
                  <Link to={`/${domain}/application/customers/${order.customer.id}`} className={'ant-btn ant-btn-default ant-btn-sm'}>
                    Customer detail
                  </Link> : null
              }
            >
              <CustomerSettings
                order={order}
                onUpdate={this.props.onUpdate}
              />

              <Divider />
              <h3>Invoicing</h3>
              <InvoicingSettings
                order={order}
                onUpdate={this.props.onUpdate}
              />

              <Divider />
              <h3>Delivery</h3>
              <DeliverySettings
                order={order}
                onUpdate={this.props.onUpdate}
              />

              <Divider />
              <h3>Notes from customer</h3>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                {!order.notes
                  ? <span style={{ color: '#999897' }}>- empty -</span>
                  : <span dangerouslySetInnerHTML={createMarkup(order.notes)} />}
              </div>

              <Divider />
              <h3>Notes to invoice</h3>
              <InvoiceNotesSettings
                order={order}
                onUpdate={this.props.onUpdate}
              />

            </Card>
          </Col>
        </Row>

        <Divider />

        <Row gutter={16}>
          <Col span={24}>
            <Card
              extra={
                <React.Fragment>
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item key="1" onClick={this.props.onAddAnotherProductItem}>Product item</Menu.Item>
                        <Menu.Item key="2" onClick={this.props.onAddAnotherNonProductItem}>Non-product item</Menu.Item>
                      </Menu>
                    }
                  >
                    <Button style={{ marginLeft: 8 }}>
                      Add another <DownOutlined />
                    </Button>
                  </Dropdown>
                </React.Fragment>
              }
              title={`Ordered items (${order.orderedItems.length})`}
              bordered={false}
              headStyle={{ paddingLeft: 16, paddingRight: 16 }}
              bodyStyle={{ padding: 0 }}
            >
              <OrderedItems
                attributes={this.props.attributes}
                order={this.props.order}
                onEditItem={this.props.onEditItem}
                onDeleteItem={this.props.onDeleteItem}
              />
            </Card>
          </Col>
        </Row>

        <Divider />
        <Row gutter={16}>
          <Col span={12}>
            <Card title={`History of changes`}>
              {order.actionRecords && Array.isArray(order.actionRecords) &&
                <List
                  itemLayout={'horizontal'}
                  dataSource={order.actionRecords}
                  renderItem={(ar: any) => {
                    return (<List.Item style={{ overflow: 'hidden' }}>
                      <Meta
                        title={<React.Fragment>{ar.type} - {ar.source}{ar.author && <React.Fragment>, by <b>{ar.author.email}</b></React.Fragment>}</React.Fragment>}
                        description={<span title={ar.newValue}>{moment(new Date(ar.createdAt)).format('DD/MM/YY hh:mm:ss')} - {ar.newValue && ar.newValue.substr(0, 100)}</span>}

                      />
                    </List.Item>
                    );
                  }}
                />}
            </Card>
          </Col>
          <Col span={12}>
            <Card title={`Comments`}>
              {orderComments && Array.isArray(orderComments) &&
                <List
                  itemLayout={'horizontal'}
                  dataSource={orderComments}
                  renderItem={(oc: any) => {
                    return (<List.Item>
                      <Meta
                        title={<React.Fragment>Comment by <b>{oc.author.email}</b> {oc.emailSent && <MailOutlined />}</React.Fragment>}
                        description={
                          <div style={{ marginTop: -4 }}>
                            <small>{moment(new Date(oc.createdAt)).format('DD/MM/YY hh:mm:ss')}</small><br />
                            <span dangerouslySetInnerHTML={createMarkup(oc.value)} style={{ color: 'rgba(0, 0, 0, 0.65)' }} />
                          </div>}
                      />
                    </List.Item>);
                  }}
                />}
              <Input.TextArea
                onChange={e => this.setState({ newComment: e.currentTarget.value })}
                value={this.state.newComment}
                placeholder={'Your new comment'}
              />
              <Divider />
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '5px' }}>
                <Button
                  onClick={() => this.submitNewComment()}
                  style={{ marginRight: '5px' }}
                  type={'primary'}
                >
                  Submit
                </Button>
                <Checkbox
                  checked={this.state.sendEmail}
                  onChange={() => this.setState({ sendEmail: !this.state.sendEmail })}
                >
                  Send email to customer
                </Checkbox>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  private getAttributes(orderItem: GQL.IOrderItem) {
    if (!this.props.attributes || !this.props.attributes.attributes) {
      return '...loading attributes';
    }

    const attributes = this.props.attributes.attributes;

    if (orderItem.definition) {
      return Object.keys(orderItem.definition)
        .reduce((acc, attrId) => {
          if (attrId === 'visual') {
            return acc;
          }

          const attribute = attributes.find((attr: any) => attr.id === attrId);

          if (attribute) {
            const attributeTitle = `${attribute && attribute.title}: ${this.getAttributeValue(attribute.values, orderItem.definition[attrId])}`;
            return `${acc}${acc && ','} ${attributeTitle}`;
          }

          return '';
        }, '');
    }

    return '';
  }

  private getAttributeValue(values: Array<any>, attrValueId: string) {
    if (values) {
      const value = values.find((attrValue: any) => attrValue.id === attrValueId);
      return (value && value.title) || '&ndash;';
    }

    return '&ndash;';
  }

  /**
   * Spočítá celkovou váhu (pro dopravu) objednávky
   */
  private getTotalShippingWeight() {
    const { order } = this.props;

    if (order && order.orderedItems) {
      return order.orderedItems.reduce((acc: number, curr: GQL.IOrderItem) => {
        if (curr.product) {
          if (curr.product.weightForShipping) {
            acc += curr.product.weightForShipping * curr.quantity;
          } else if (curr.product.weight) {
            acc += curr.product.weight * curr.quantity;
          }
        }
        return acc;
      }, 0);
    }

    return null;
  }

  private submitNewComment() {
    if (this.state.newComment != '') {
      this.props.onNewComment(this.state.newComment, this.state.sendEmail);
      this.setState({
        newComment: '',
        sendEmail: false
      });
    }
  }
}

export default withRouter(OrderInformation);



// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/OrderInformation.tsx